
import { Vue } from "vue-class-component";

export default class SuccessStatus extends Vue {}
